<template>
	<div class="administratormanagement">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">管理员管理</div>
					<div class="contentcard">
						<div style="font-size: 14px; font-weight: 700;">搜索管理员</div>
						<a-divider dashed style="margin: 10px 0;" />
						<div>
							<div style="width: 400px;display: inline-block;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;margin-right: 10px;">手机号码</span>
								<a-input placeholder="请输入手机号码" style="width: 260px" v-model="searchlist.phone_number" />
							</div>
							<a-button type="primary" size="small" style="width: 96px;font-size: 12px;" @click="searchbtn">搜索</a-button>
						</div>
					</div>
					<div class="contentcard">
						<div style="padding-bottom: 50px;">
							<div>
								<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
									<a-spin />
								</div>
								<div v-if="(!adminlist.length)&&(!issearch)">
									<a-alert message="查询结果为空" banner type="info" />
								</div>
								<div v-if="adminlist.length">
									<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
										<a-col :span="2" style="text-align: center;">ID</a-col>
										<a-col :span="2" style="text-align: center;">用户名</a-col>
										<a-col :span="3" style="text-align: center;">显示名</a-col>
										<a-col :span="2" style="text-align: center;">手机号码</a-col>
										<a-col :span="2" style="text-align: center;">手机验证</a-col>
										<a-col :span="2" style="text-align: center;">Email</a-col>
										<a-col :span="2" style="text-align: center;">是否激活</a-col>
										<a-col :span="2" style="text-align: center;">权限组</a-col>
										<a-col :span="6" style="text-align: center;">操作</a-col>
									</a-row>
								</div>
								<div style="color: #666;font-size: 14px;" v-for="admin in adminlist" :key="admin">
									<a-row type="flex" justify="space-around" align="middle" style="border-bottom: #e8e8e8 dashed 1px;min-height: 60px;padding: 5px 0;">
										<a-col :span="2" style="text-align: center;" @click="gotoadmininfo(admin)"><a>{{admin.id}}</a></a-col>
										<a-col :span="2" style="text-align: center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
											<a-popover placement="topLeft" trigger="hover">
												<template slot="content">
													<p>{{admin.username}}</p>
												</template>
												{{admin.username}}
											</a-popover>
										</a-col>
										<a-col :span="3" style="text-align: center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
											<a-popover placement="topLeft" trigger="hover">
												<template slot="content">
													<p>{{admin.display_name}}</p>
												</template>
												{{admin.display_name}}
											</a-popover>
										</a-col>
										<a-col :span="2" style="text-align: center;">{{admin.phone_number}}</a-col>
										<a-col :span="2" style="text-align: center;">
											<a-icon type="check-circle" style="color: green;" v-if="admin.phone_verified" />
											<a-icon type="close-circle" style="color: red;" v-else />
										</a-col>
										<a-col :span="2" style="text-align: center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
											<a-popover placement="topLeft" trigger="hover">
												<template slot="content">
													<p>{{admin.email}}</p>
												</template>
												{{admin.email}}
											</a-popover>
										</a-col>
										<a-col :span="2" style="text-align: center;">
											<a-icon type="check-circle" style="color: green;" v-if="admin.is_active" />
											<a-icon type="close-circle" style="color: red;" v-else />
										</a-col>
										<a-col :span="2" style="text-align: center;">{{permission_group_name(admin.permission_group_id)}}</a-col>
										<a-col :span="6" style="text-align: center;">
											<div>
												<a-button size="small" type="primary" ghost style="width: 96px;font-size: 12px;" @click="admin_btn(admin)">编辑</a-button>
												<a-button size="small" type="danger" ghost style="width: 96px;font-size: 12px;" @click="deletebtn(admin)">删除</a-button>
											</div>
										</a-col>
									</a-row>
								</div>
							</div>
							<div style="float: right;position: relative;bottom: -18px;">
								<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize" :total="adminsum"
								 showQuickJumper @change="pageChange" />
							</div>
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>

		<a-modal title="编辑管理员" :width="600" :visible="admin_visible" @ok="admin_Ok" :confirmLoading="adminLoading" @cancel="admin_Cancel">
			<div style="">
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">用户名</span>
					<a-input style="width: 250px;" disabled v-model="admin_info.username" placeholder="请输入用户名" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">密码</span>
					<a-input style="width: 250px;" :disabled="!admin_info.repassword_status" type="password" v-model="admin_info.repassword"
					 placeholder="请输入密码" />
					<a-button v-show="!admin_info.repassword_status" style="margin-left: 20px;" @click="()=>{admin_info.repassword_status =true;admin_info.repassword =null}">
						修改密码 </a-button>
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">显示名</span>
					<a-input style="width: 250px;" v-model="admin_info.display_name" placeholder="请输入显示名" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">手机号码</span>
					<a-input style="width: 250px;" v-model="admin_info.phone_number" placeholder="请输入手机号码" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">手机验证</span>
					<a-switch v-model="admin_info.phone_verified" :disabled="!admin_info.phone_number" checkedChildren="是"
					 unCheckedChildren="否" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">Email</span>
					<a-input style="width: 250px;" v-model="admin_info.email" placeholder="请输入Email地址" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">Email验证</span>
					<a-switch v-model="admin_info.email_verified" :disabled="!admin_info.email" checkedChildren="是" unCheckedChildren="否" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">是否激活</span>
					<a-switch v-model="admin_info.is_active" checkedChildren="是" unCheckedChildren="否" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">是否雇员</span>
					<a-switch v-model="admin_info.is_staff" checkedChildren="是" unCheckedChildren="否" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">权限组设置</span>
					<a-select placeholder="请选择" style="width: 250px" v-model="admin_info.permission_group_id" @change="(value)=>{admin_info.permission_group_id = value}">
						<a-select-option :value="item.id" v-for="item in permission_group" :key="item">{{item.permission_group_name}}</a-select-option>
					</a-select>
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">是否CMS管理员</span>
					<a-switch v-model="admin_info.is_cms" checkedChildren="是" unCheckedChildren="否" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 150px;text-align: right;margin-right: 20px;">是否超级管理员</span>
					<a-switch v-model="admin_info.is_super" checkedChildren="是" unCheckedChildren="否" />
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import CryptoJS from 'crypto-js';

	export default {

		data() {
			return {
				current: ['administratormanagement'],
				openKeys: ['usermanagement'],
				searchlist: {
					phone_number: null
				},
				adminlist: [],
				adminsum: 0,
				startpage: this.$route.query.startpage || 0,
				endpage: this.$route.query.endpage || 10,
				pageSize: Number(this.$route.query.pageSize) || 10,
				issearch: false,
				admin_visible: false,
				adminLoading: false,
				permission_group: [],
				admin_info: {},
			}
		},
		created: function() {
			if (this.$route.query.searchlist) {
				this.searchlist = JSON.parse(this.$route.query.searchlist);
			}
			this.initialize();
		},
		methods: {
			initialize() {
				var self = this;
				this.issearch = true;
				this.adminlist = [];
				this.adminsum = 0;
				var params = {
					searchlist: this.searchlist,
					startpage: this.startpage,
					pageSize: this.pageSize
				};
				this.$axios.get('/permission/adminlist', {
					params: params
				}).then(function(res) {
					self.adminlist = res.data.adminlist;
					self.adminsum = res.data.adminsum;
					self.permission_group = res.data.permission_group;
					self.issearch = false;

				});
			},
			onShowSizeChange(current, pageSize) {
				this.pageSize = pageSize;
				this.startpage = this.pageSize * (current - 1);
				this.endpage = this.pageSize * current;
				this.initialize();
				this.$router.push({
					name: 'administratormanagement',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist)
					}
				})

			},
			pageChange(pageNumber) {
				this.startpage = this.pageSize * (pageNumber - 1);
				this.endpage = this.pageSize * pageNumber;
				this.initialize();
				this.$router.push({
					name: 'administratormanagement',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist)
					}
				})
			},
			searchbtn() {
				this.startpage = 0;
				this.endpage = this.pageSize;
				// this.pageSize = 10;
				this.initialize();
				this.$router.push({
					name: 'administratormanagement',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist)
					}
				})
			},
			gotoadmininfo(admin) {
				console.log(admin);
			},
			admin_btn(admin) {
				admin.repassword_status = false;
				admin.repassword = "******";
				this.admin_info = JSON.parse(JSON.stringify(admin));
				this.admin_visible = true;
			},
			admin_Ok() {
				if (!this.admin_info.username) {
					return this.$message.error("用户名不能为空");
				}
				if (this.admin_info.repassword_status && !this.admin_info.repassword) {
					return this.$message.error("重置密码不能为空");
				}
				if (!this.admin_info.display_name) {
					return this.$message.error("显示名不能为空");
				}
				this.adminLoading = true;
				if (this.admin_info.repassword_status) {
					this.admin_info.repassword = CryptoJS.MD5(this.admin_info.repassword).toString(CryptoJS.enc.Hex);
				}
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否更新管理员信息',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/permission/administratormanagement/updated', {
							params: {
								admin_info: self.admin_info
							}
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.initialize();
							self.adminLoading = false;
							self.admin_visible = false;
							
						});
					},
					onCancel() {},
				});
			},
			admin_Cancel() {
				this.admin_visible = false;
				this.adminLoading = false;
			},
			permission_group_name(id) {
				for (var i = 0; i < this.permission_group.length; i++) {
					if (id == this.permission_group[i].id) {
						return this.permission_group[i].permission_group_name
					}
				}
			},
			deletebtn(admin){
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否删除此管理员',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/permission/administratormanagement/delete', {
							params: {
								id: admin.id
							}
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.initialize();
							
						});
					},
					onCancel() {},
				});
			}


		},

	};
</script>

<style>

	.administratormanagement .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// index.vue?62c9fb4b